import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
import {PageBuilderOptions} from "./editor/LandingPageEditorOptions.js";
import {LandingPageEditor} from "./editor/LandingPageEditor.js";

export class ZIDXAccountLandingPageEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountLandingPageEditContainer";
    }
    render(){
        // console.log("landing page edit");
        let pageBuilderOptions=new PageBuilderOptions();
        pageBuilderOptions.containerId="zidxPageBuilderEditor";
        pageBuilderOptions.formsContainerId="zidxPageBuilderForms";
        pageBuilderOptions.debugContainerId="zidxPageBuilderDebug";
        let pageBuilder=new LandingPageEditor(pageBuilderOptions, this.zidx);
        pageBuilder.render();
    }
}